module.exports = __webpack_public_path__ + "img/avatar1.2fd1c3f8.jpg";